import React from 'react';

const LoadMoreButton = ({
  isLoadingMore,
  loadMoreConversations,
  page,
  totalPages,
}: {
  isLoadingMore: boolean;
  loadMoreConversations: any;
  page: number;
  totalPages: number;
}) => {
  return (
    <div className="flex justify-center items-center">
      {!isLoadingMore ? (
        <button
          className="border border-white border-opacity-50 py-1 px-2 rounded text-white text-opacity-50 hover:text-opacity-80 hover:border-opacity-80 transition-colors text-xs"
          onClick={loadMoreConversations}
          disabled={page >= totalPages}
        >
          {page >= totalPages ? 'No more conversations' : 'Load more'}
        </button>
      ) : (
        <div className="w-5 h-5 border-2 border-white border-opacity-50 border-t-transparent rounded-full animate-spin"></div>
      )}
    </div>
  );
};

export default LoadMoreButton;
